// import CourseList from '../components/CourseList';

const home = () => {
    return (
        <section className="hero is-medium is-primary is-bold">
            <div className="hero-body">
                <div className="container">
                    <header className="level">
                        <div className="level-left">
                            <div className="level-item">
                                <h1 className="title">Twoje kursy</h1>
                            </div>
                        </div>
                    </header>

                    {/* <CourseList></CourseList> */}
                </div>
            </div>
        </section>
    );
};

export default home;
